import type {
  ContractRecordMap,
  PlannableOverlapExtended
} from '@libs/data-access/entities'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { isMemberValidForRTT } from '@spa/features/RTT'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'

/**
 * Format contracts to be used in Select component
 */
export const useFormattedContractOptions = (
  contracts: ContractRecordMap,
  plannableOverlapExtended: PlannableOverlapExtended,
  restType: string
) => {
  const { t, tCommon } = usePlanningFormTranslation()

  const membershipsMap = membershipsSelectors.useGetCachedMap()

  return contracts
    .toArray()
    .map(contract => {
      const shouldHighlight =
        (plannableOverlapExtended.byContractId?.[contract.id]
          ?.other_rest_count ?? 0) +
        (plannableOverlapExtended.byContractId?.[contract.id]
          ?.weekly_rest_count ?? 0)
      const membership = membershipsMap[contract.membership_id]

      return {
        ...(shouldHighlight && {
          highlight: 'danger' as const,
          tooltip: t('restForm.warningAlreadyRest')
        }),
        value: String(contract.id),
        label: tCommon('models.fullname', {
          value: {
            firstname: membership?.firstname,
            lastname: membership?.lastname
          }
        })
      }
    })
    .filter(entity => {
      const entityContract = contracts.find(
        contract => entity.value === String(contract?.id)
      )

      if (
        restType === 'rtt' &&
        !isMemberValidForRTT({
          contract_type: entityContract.contract_type,
          contract_time: entityContract.contract_time,
          isDailyWorker: entityContract.daily_worker
        })
      ) {
        return false
      }
      return true
    })
    .sort((a, b) => a.label.localeCompare(b.label))
}
